var _circle, _path, _circle2, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 106 106",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#E4E4E4",
    cx: 53,
    cy: 53,
    r: 53
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D0D0D0",
    d: "M106 53c0-2-.1-4-.3-6L63.5 22.5 22.8 79.9l25.9 25.9c1.4.1 2.9.2 4.4.2 29.2 0 52.9-23.7 52.9-53z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#8D8D8D",
    cx: 53,
    cy: 79.7,
    r: 9.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#595959",
    d: "m53 69.8-.1 19.8h.1c5.5-.2 9.8-4.8 9.6-10.2-.2-5.2-4.4-9.4-9.6-9.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M80.7 73.7H25.3l11.2-42.1c2.4-9.1 11.8-14.6 20.9-12.2C63.3 21 68 25.6 69.5 31.5l11.2 42.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M69.5 31.5c-2-7.5-8.8-12.7-16.5-12.7h-.1v54.8h27.8L69.5 31.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3F3F3",
    d: "M22.8 67.4h60.4v12.5H22.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    d: "M53 67.4h30.2v12.5H53z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellCircle);
export default __webpack_public_path__ + "static/media/bell-circle.28d2e6d26c7ad84f71370a74bc748cf4.svg";
export { ForwardRef as ReactComponent };